import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type DecisionDashboard } from '../../api/decision';

export function ExecutiveCockpitPage() {
  const [dashboard, setDashboard] = useState<DecisionDashboard | null>(null);

  useEffect(() => {
    void decisionApi.dashboard((getWorkspaceId() ?? '')).then(setDashboard);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Executive Cockpit</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Strategic intelligence overview for C-suite decision making.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      {dashboard?.platform_health && (
        <div className="mt-6">
          <h2 className="font-medium">Platform Connectivity</h2>
          <div className="mt-3 grid gap-2 sm:grid-cols-3">
            {dashboard.platform_health.map((m) => (
              <div key={m.module} className="rounded border px-3 py-2 text-sm dark:border-slate-700">
                <span className="capitalize">{m.module}</span>
                <span className={`ml-2 ${m.status === 'healthy' ? 'text-green-600' : 'text-amber-600'}`}>{m.status}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="mt-8 grid gap-4 sm:grid-cols-3">
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">Strategic Decisions</p>
          <p className="text-2xl font-semibold">{dashboard?.total_decisions ?? 0}</p>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">AI Recommendations</p>
          <p className="text-2xl font-semibold">{dashboard?.open_recommendations ?? 0}</p>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">Autonomous Agents</p>
          <p className="text-2xl font-semibold">{dashboard?.active_agents ?? 0}</p>
        </div>
      </div>
    </div>
  );
}
